import { ProductoPresentacion } from './ProductoPresentacion';


export class ReporteProductosInformacion {
    productoPresentacion:ProductoPresentacion;
    cantidad:number;
    promedio:number;
    ganancia:number;
    cantidadOrdenes:number;
}